export default class UI_ProgressBar extends Phaser.Group {
  /**
   * This is the progress bar seen on the top bar in the game
   * Its like a n shape and marks your points progress
   * @param {number} x
   * @param {number} y
   */
  constructor(x, y) {
    super(game);

    const lvl = G.lvlData;

    this.x = G.l(x);
    this.y = G.l(y);

    this._points = 0;
    this._pointsTarget = 0;
    this._barMaxPoints = lvl.starsReq[2] * 1.2;

    this.barProgress = G.makeImage(0, 0, 'ingame_progress_bar', [0.5, 1], this); // Accessed externally

    this._barProgressMask = game.add.graphics();
    this.add(this._barProgressMask);
    this._barProgressMask.position = this.barProgress.position;
    this.barProgress.mask = this._barProgressMask;

    this._barProgressMask.beginFill(0x000000);
    G.drawCircleSegment(this._barProgressMask, 0, 0, 100, 170, 171);

    const distance = 84;

    this.stars = [
      G.makeImage(
        G.lengthDirX(this._pointsToAngle(lvl.starsReq[0]), distance + 15, false),
        5 + G.lengthDirY(this._pointsToAngle(lvl.starsReq[0]), distance + 15, false),
        'progress_bar_star_1', 0.5, this,
      ),
      G.makeImage(
        G.lengthDirX(this._pointsToAngle(lvl.starsReq[1]), distance + 15, false),
        5 + G.lengthDirY(this._pointsToAngle(lvl.starsReq[1]), distance + 15, false),
        'progress_bar_star_2', 0.5, this,
      ),
      G.makeImage(
        G.lengthDirX(this._pointsToAngle(lvl.starsReq[2]), distance + 15, false),
        5 + G.lengthDirY(this._pointsToAngle(lvl.starsReq[2]), distance + 15, false),
        'progress_bar_star_3', 0.5, this,
      ),
    ];

    this.stars.forEach((elem, index) => {
      elem.req = lvl.starsReq[index];
    });

    this._tweenObj = undefined; // To track to clean up later
    this._signalbinding = G.sb('onPointsChange').add((amount) => {
      this._pointsTarget = amount;
    });
  }

  /**
   * Destroy!
   */
  destroy() {
    if (this._signalbinding) {
      if (this._signalbinding.detach) {
        this._signalbinding.detach();
      }
      this._signalbinding = null;
    }
    if (this._tweenObj) {
      this._tweenObj.stop();
      this._tweenObj = null;
    }
    super.destroy();
  }

  /**
   * Clamps the number down
   * @param {number} points
   */
  _pointsToAngle(points) {
    return game.math.clamp(180 + (points / this._barMaxPoints) * 180, 0, 380);
  }

  /**
   * Progress bar tweens into shape here
   */
  update() {
    if (this._points === this._pointsTarget) return;
    this._changePoints(game.math.clamp(Math.ceil((this._pointsTarget - this._points) * 0.05), 0, this._pointsTarget - this._points));
  }

  /**
   * The visuals of the increasing points
   * @param {number} change
   */
  _changePoints(change) {
    const oldPoints = this._points;
    this._points += change;

    this._barProgressMask.clear();
    this._barProgressMask.beginFill(0x000000);
    G.drawCircleSegment(this._barProgressMask, 0, 0, 100, 90, this._pointsToAngle(this._points));

    for (let i = 0; i < 3; i++) {
      if (oldPoints < this.stars[i].req && this.stars[i].req <= this._points) {
        G.lvl.stars++;

        if (i < 2) {
          G.sfx.xylophone_positive.play();
        } else {
          G.sfx.xylophone_positive2.play();
        }

        this._tweenObj = game.add.tween(this.stars[i].scale).to({ x: 1.5, y: 1.5 }, 300, Phaser.Easing.Sinusoidal.InOut, true, 0, 0, true);

        for (let iterator = 0; iterator < 4; iterator++) {
          G.sb('UIfx').dispatch(this.stars[i].worldPosition.x + game.world.bounds.x, this.stars[i].worldPosition.y, 'whiteStarPart');
        }
      }
    }
  }
}
